function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M1.394 18.916C.754 19.214 0 18.678 0 17.903v-14.9c0-.714.406-1.37.987-1.608L3.832.084c.639-.298 1.394.238 1.394 1.013v14.9c0 .714-.407 1.37-.987 1.608l-2.845 1.311zm8.825 0c.64.298 1.394-.238 1.394-1.013v-14.9c0-.714-.407-1.37-.987-1.608L7.78.084c-.64-.298-1.394.238-1.394 1.013v14.9c0 .714.407 1.37.987 1.608l2.845 1.311zm3.949 0c-.639.298-1.394-.238-1.394-1.013v-14.9c0-.714.407-1.37.987-1.608L16.606.084C17.246-.214 18 .322 18 1.097v14.9c0 .714-.406 1.37-.987 1.608l-2.845 1.311z",
  fill: "#051D39",
  fillRule: "evenodd"
});

function SvgMapTypeRoadmap(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref);
}

export default SvgMapTypeRoadmap;